import { render, staticRenderFns } from "./ReturnPage.vue?vue&type=template&id=60b59477&"
import script from "./ReturnPage.vue?vue&type=script&lang=ts&"
export * from "./ReturnPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports